import type { LoaderFunctionArgs } from 'react-router';

/**
 * react-query + router loader example taken from:
 *
 * https://tanstack.com/query/latest/docs/framework/react/examples/react-router
 * https://tkdodo.eu/blog/react-query-meets-react-router
 *
 * Pages should fetch using react-query based on the ID via useSuspenseQuery
 */

export const policyLoader = ({ params }: LoaderFunctionArgs) => {
  const { id } = params;
  if (!id) {
    throw new Error('No ID provided');
  }
  return { policyId: id };
};
